import { CLIENT_PAYMENT_LIST_REQUEST,
  CLIENT_PAYMENT_LIST_SUCCESS,
  CLIENT_PAYMENT_LIST_FAILURE,
    ADD_CLIENT_PAYMENT_REQUEST,
    ADD_CLIENT_PAYMENT_SUCCESS,
    ADD_CLIENT_PAYMENT_FAILURE,
    PAYMENT_DETAIL_LIST_REQUEST,
    PAYMENT_DETAIL_LIST_SUCCESS,
    PAYMENT_DETAIL_LIST_FAILURE,
    DELETE_CLIENT_PAYMENT_REQUEST,
    DELETE_CLIENT_PAYMENT_SUCCESS,
    DELETE_CLIENT_PAYMENT_FAILURE
 } from "actions/ClientPayment/clientPaymentAction";

 const initialState = {
    paymentList: [],
    paymentDetailList: [],
    paymentDetails: {},
    paymentData: {},
    paymentDeleted:false
  };
  
  export default function clientPaymentReducer(
    state = initialState,
    action
  ) {
    switch (action.type) {
      case CLIENT_PAYMENT_LIST_REQUEST:
        return {
          ...state
        };
      case CLIENT_PAYMENT_LIST_SUCCESS:
        return {
          ...state,
          paymentList: action.payload
        };
      case CLIENT_PAYMENT_LIST_FAILURE:
        return {
          ...state,
          error: action.payload
        };
        case PAYMENT_DETAIL_LIST_REQUEST:
          return {
            ...state
          };
        case PAYMENT_DETAIL_LIST_SUCCESS:
          return {
            ...state,
            paymentDetailList: action.payload
          };
        case PAYMENT_DETAIL_LIST_FAILURE:
          return {
            ...state,
            error: action.payload
          };
        case ADD_CLIENT_PAYMENT_REQUEST:
      return {
        ...state
      };
    case ADD_CLIENT_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentDetails: action.payload
      };
    case ADD_CLIENT_PAYMENT_FAILURE:
      return {
        ...state,
        error: action.payload
      };
      case DELETE_CLIENT_PAYMENT_REQUEST:
        return {
          ...state
        };
      case DELETE_CLIENT_PAYMENT_SUCCESS:
        return {
          ...state
        };
      case DELETE_CLIENT_PAYMENT_FAILURE:
        return {
          ...state,
          error: action.payload
        };
      case 'DELETE_PAYMENT_SUCCESS':
        return {
          ...state,
          paymentDeleted: true
        };
      case 'RESET_PAYMENT_DELETED':
        return {
          ...state,
          paymentDeleted: false
        };
      case 'PAYMENTDETAIL':
        if (!action.payload) {
          return initialState;
        } else {
          return {
            ...state,
            paymentData: action.payload
          };
        }
      case 'PAYMENTDATA':
        if (!action.payload) {
          return initialState;
        } else {
          return {
            ...state,
            paymentData: action.payload
          };
        }
      default:
        return state;
    }
  }